import { API } from 'aws-amplify'

export default async params => {
  return API.get('process', `datapoints?processId=${params.processId}&streamId=${params.streamId}&numberOfPoints=${params.numberOfPoints}&start=${params.start}&end=${params.end}`)
}
